import { Draft } from 'immer';
import { Euler, Quaternion } from 'three';

import { CameraProperties, DesignCameraSettings, sanitizeRotation } from './types';

export function updateCameraForFlippedAndReversedSettings(
  camera: Draft<CameraProperties>,
  settings: {
    flipped: boolean;
    reversed: boolean;
  },
) {
  const zPositionShouldBePositive = shouldZPositionBePositive(settings);
  const shouldInvertZ = zPositionShouldBePositive ? camera.position.z < 0 : camera.position.z > 0;

  if (shouldInvertZ) camera.position.z = -camera.position.z;

  const rotation = calculateDesignCameraRotation(settings);
  camera.rotation = sanitizeRotation(rotation);
}

export function shouldZPositionBePositive(settings: DesignCameraSettings) {
  return settings.flipped === settings.reversed;
}

export function calculateDesignCameraRotation(settings: DesignCameraSettings) {
  return getFlippedQuaternion(settings.flipped).multiply(getReversedQuaternion(settings.reversed));
}

function getFlippedQuaternion(flipped: boolean) {
  return new Quaternion().setFromEuler(flipped ? new Euler(Math.PI, 0, 0) : new Euler());
}

function getReversedQuaternion(reversed: boolean) {
  return new Quaternion().setFromEuler(reversed ? new Euler(0, Math.PI, 0) : new Euler());
}
